<template>
    <div id="userCenterPage" v-if="canbeShow">
      <div class="left">
        <leftMenu @change="changeType" :menuIndex="menuIndex"/>
      </div>
      <div id="right" :class="$root.isMob() ? 'right mob' : 'right'">
        <div v-if="type == 'home'">
          <userData @linkto="linkto"/>
        </div>
        <div v-if="type == 'info'" class="userCenter">
          <userCenter @linkto="linkto"/>
        </div>
        <div v-if="type == 'unity'||type == 'unityVr'" class="unityCenter">
          <unityCenter @viewDetail="viewDjDetail" :clinet="type"/>
        </div>
        <div v-if="type == 'unityLog'" class="unityLog">
          <logList :key="'unityLog-1'" :logId="parseInt(unityExamId)" :type="1" :title="'考核记录'" @isViewing="unityExamId=null"/>
        </div>
        <div v-if="type == 'unityTestLog'" class="unityLog">
          <logList :key="'unityTestLog-6'" :type="6" :title="'练习记录'"/>
        </div>
        <div v-if="type == 'tests'" class="tests">
          <testsCenter @viewDetail="viewTestsDetail"/>
        </div>
        <div v-if="type == 'practice'" class="tests">
          <testsCenter :type="2" title="题库练习" @viewDetail="viewTestsDetail"/>
        </div>
        <div v-if="type == 'testsLog'" class="tests">
          <logList :key="'testsLog-2'" :type="2" :title="'答题记录'"/>
        </div>
        <div v-if="type == 'practiceLog'" class="tests">
          <logList :key="'practiceLog-3'" :type="3" :title="'答题记录'"/>
        </div>

        <div v-if="type == 'modelShow'">
          <modelShowList @showDetail="showModDetail"/>
        </div>
        <div v-if="type == 'modelDetail'" class="modelDetail">
          <modelDetail :id="modId" @changeId="changeModelDetail"/>
        </div>

        <div v-if="type == 'testsdetail'" class="testsdetail">
          <testsDetail :id="testsID" :title="testsTitle" @return="type = 'tests'"/>
        </div>
        <div v-if="type == 'testsBankdetail'" class="testsdetail">
          <testsDetail :isPractice="true" title="题库练习" :id="testsID" @return="type = 'practice'"/>
        </div>
        <div v-if="type == 'unityDetail'" class="unityDetail">
          <unityDetail :id="unityID" @return="changeType"/>
        </div>

        <div v-if="type == 'learn'" class="unityCenter">
          <learnCenter @viewDetail="viewLearnDetail"/>
        </div>
        <div v-if="type == 'learnDetail'" class="learnDetail">
          <learnDetail :id="learnID" @return="type = 'learn'"/>
        </div>
      </div>              
    </div>
</template>

<script>
import userCenter from '@/components/lib/userCenter.vue';
import leftMenu from '../lib/leftMenu.vue';
import unityCenter from '../lib/unityCenter.vue';
import unityDetail from '../lib/unityDetail.vue';
import testsCenter from '../lib/testsCenter.vue';
import logList from '../lib/logList.vue';
import userData from '../lib/userData.vue';
import testsDetail from '../lib/testsDetail.vue';
import learnCenter from '../lib/learnCenter.vue';
import learnDetail from '../lib/learnDetail.vue';
import modelShowList from  '../lib/modelShowList.vue';
import modelDetail from '../lib/modelDetail.vue';

export default {
  name: 'userCenterPage',
  components: {
    userCenter,
    leftMenu,
    unityCenter,
    unityDetail,
    logList,
    testsCenter,
    userData,
    testsDetail,
    learnCenter,
    learnDetail,
    modelShowList,
    modelDetail,
  },
  watch: {
    'type'() {
      if(this.type != 'testsdetail'){
        this.menuIndex = this.type;
      }      
    }
  },
  data() {
    return {
      type: 'home',
      urlType:"",
      testsID:"",
      testsTitle:"",
      unityID:"",
      unityExamId:"",
      learnID:"",
      menuIndex:"",
      modId:"-1",
      canbeShow:false,
    }
  },
  methods: {
    changeType(type){
      this.type = type;
    },
    changeModelDetail(id){
      this.modId = id;
    },
    showModDetail(id){
      this.modId = id;
      this.type = "modelDetail";
    },
    viewTestsDetail(id,title,type){
      if(type == 1){
        this.type = 'testsdetail';
      }
      if(type == 2){
        this.type = 'testsBankdetail';
      }
      this.testsID = id;
      this.testsTitle = title;
    },
    viewDjDetail(id){
      this.type = 'unityDetail';
      this.unityID = parseInt(id);
    },
    viewLearnDetail(id){
      this.type = 'learnDetail';
      this.learnID = parseInt(id);
    },
    viewUnityExamInfo(id){
      this.type = "unityLog";
      this.unityExamId = parseInt(id);
    },
    async checkLogin(){
      this.canbeShow = false;
      let isLogin = await this.$root.checkLogin();
      if(!isLogin){
        if(this.$root.isMob()){
          this.$router.replace({
            name:'home',
            query:{redirect:this.$route.query}
          });
          return
        }
        this.$router.replace({
          name:'login',
          query:{redirect:this.$route.query}
        });
        return;
      }
      this.canbeShow = true;
    },
    linkto(type){
      this.type = type;
    },
  },
  created() {
    this.checkLogin();
    if(this.$route.query.djId){
      this.viewDjDetail(this.$route.query.djId,"")
    }
    if(this.$route.query.learnId){
      this.viewLearnDetail(this.$route.query.learnId,"")
    }
    if(this.$route.query.unityExamId){
      this.viewUnityExamInfo(this.$route.query.unityExamId);
    }
    //移除路由中的所有query 并且不触发路由刷新
    let newHash = window.location.href.split('?')[0];
    window.history.replaceState({}, '', newHash);
  },
  mounted() {
    this.$nextTick(() => {
      this.$root.checkViewPort('right');
    });
  }
}
</script>

<style lang="scss" scoped src="@/assets/css/userCenterPage.scss">
</style>